export const mockGetSelectedMonitor = function () {
  return [{
    id: 0,
    create_time: 1701844333789,
    update_time: 1701844449092,
    update_user: 1,
    create_user: 1,
    scene_id: 1,
    keycode: '1206保温箱',
    description: '',
    status: 0,
    tag: '',
    typeId: 1,
    code: '',
    abnormal: 0,
    alarm_switch: 1,
    alarm_bind: 1,
    is_trace: 1,
    sample_value: '{"hum":[],"temp":[]}',
    sample_strategy: 1,
    mode: 1,
    unit_text: ''
  }]
}
